var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 80,
    viewBox: "0 0 70 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-file-3946982",
    transform: "translate(-182.741 -58.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6647",
    "data-name": "Trazado 6647",
    d: "M240.191,236.373h33.392a1.391,1.391,0,1,0,0-2.783H240.191a1.391,1.391,0,1,0,0,2.783Z",
    transform: "translate(-47.145 -144.212)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6648",
    "data-name": "Trazado 6648",
    d: "M274.353,303.36H240.961a1.391,1.391,0,1,0,0,2.783h33.392a1.391,1.391,0,0,0,0-2.783Z",
    transform: "translate(-47.793 -201.669)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6649",
    "data-name": "Trazado 6649",
    d: "M240.494,110.925V81.617a1.488,1.488,0,0,0-.449-1.227L215.7,58.853c-.025-.022-.061-.021-.087-.041a1.473,1.473,0,0,0-.592-.275l-.324-.067H187.15a4.392,4.392,0,0,0-3.116,1.306,4.485,4.485,0,0,0-1.293,3.15v61.851a4.488,4.488,0,0,0,1.293,3.151,4.389,4.389,0,0,0,3.116,1.308h39.04a13.774,13.774,0,0,0,6.086,7.4A13.562,13.562,0,0,0,249.8,133.22a13.924,13.924,0,0,0-.774-18.025,13.611,13.611,0,0,0-8.532-4.27ZM216.221,63.4l18.772,16.61H217.585a1.374,1.374,0,0,1-1.364-1.382Zm-29.072,62.76a1.374,1.374,0,0,1-1.366-1.382V62.927a1.374,1.374,0,0,1,1.366-1.379h26.026V78.626a4.488,4.488,0,0,0,1.293,3.151,4.389,4.389,0,0,0,3.116,1.308h20.009v27.838a13.486,13.486,0,0,0-7.4,3.22H194.052a1.538,1.538,0,0,0,0,3.077h33.46a12.266,12.266,0,0,0-2.009,8.938Zm51.895,9.23h0a10.6,10.6,0,0,1-7.532-3.154,10.851,10.851,0,0,1,0-15.229,10.571,10.571,0,0,1,15.065,0,10.843,10.843,0,0,1,0,15.225,10.6,10.6,0,0,1-7.529,3.158Z",
    transform: "translate(0 0)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6650",
    "data-name": "Trazado 6650",
    d: "M478.6,393.125l-5.358-5.337a1.4,1.4,0,0,0-.414-.273c-.013-.006-.019-.02-.032-.026h-.009a1.377,1.377,0,0,0-.7-.071,1.278,1.278,0,0,0-.173.034,1.346,1.346,0,0,0-.608.324l-.019.011-5.506,5.44a1.391,1.391,0,1,0,1.957,1.978l3.141-3.1.016,8.978h0a1.392,1.392,0,0,0,1.391,1.389h0a1.391,1.391,0,0,0,1.388-1.394l-.016-8.944,2.981,2.968a1.391,1.391,0,1,0,1.962-1.973Z",
    transform: "translate(-231.678 -268.98)",
    fill: "#ffffff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step_2.18dfc1bd44d67e5faedb2caa0115e20d.svg";
export { ForwardRef as ReactComponent };